/* Snatched smart search: Arabic/English aliases, typo correction, closest-match fallback. */
(function () {
  'use strict';

  var BRANDS = 'nike jordan adidas puma asics balance onitsuka tiger salomon alo yoga birkenstock ugg zegna loro piana golden goose balenciaga alexander mcqueen louis vuitton dior valentino garavani santoni maison margiela brunello cucinelli gucci prada chanel alaia saint laurent fendi moncler lanvin emporio armani dolce gabbana hermes martens supreme loewe zendaya bodega stussy bonner wales freshgoods miu cloud running';
  var MODELS = 'air force max dunk cortez blazer vomero zoom court legacy lift tekno m2k v2k mind jumbo remastered retro samba gazelle campus spezial spezila handball superstar stan smith forum tokyo adizero evo taekwondo mei yeezy boost speedcat speed cat rose mexico sabot tokuten tgrs kayano gel nyc 9060 327 530 574 550 2002r 1906r 1906a 204l 990 991 cloudmonster cloudtilt cloudsurfer cloudnova cloudboom cloudwander cloudvista cloudsolo cloudrunner cloudx cloudswift roger advantage tofu arizona boston madrid naples birkenstock birkibuc tasman tazz classic mini ultra platform disquette scuffette lowmel funkette chillapeak tazzlita tazzle bailey bow dipper funnket micro rocky oran chypre izmir giulia bouncing stitch secondskin runner trainer skate sneakerina track ball star super true stardan sole odsy office ooo flow screener prax tread slick tabi ballerina ballerinas flats mules loafers loafer sandals sandal slides slide slippers slipper boots boot clogs clog sneakers sneaker trainers shoes shoe kids women womens mens men wmns lv sl og rs sd pro low high mid ice sail oreo thunder fire military money black cat toe paris wolf yoga travis scott panda';
  var OTHER = 'white grey gray blue navy red green pink brown beige cream ivory gold silver metallic orange purple yellow tan taupe olive burgundy maroon sand sage mocha chestnut camel khaki charcoal gum suede leather nubuck canvas mesh knit nylon patent glitter sequins leopard snakeskin python denim linen cotton raffia satin tweed calfskin lambskin goatskin crystal flame frost eclipse glacier midnight shadow haze cement chocolate caramel cacao mushroom timberwolf moonbeam magnet indigo cinder onyx bone static reflective triple tail light bleu clair noir babouche venice charms walk summer waterfall melange glitter skins heel tab foxing studs lettering nappa naplak sparkle ltd rockstud untitled open rockrunner tonal cutout embossed oversized logo print contrasting solo milano patent striped trailgrip lite3 ftx gtx hardware palladium dorado copper weichbettung shaggy thyme oiled buckled buckle soft footbed flor narrow fit wrapped crossover double strap woven raffia plume satin ruffled embroidered vienne laser fluo multi python graffiti sprint recycled bicolor total all full off whiteout wander mauve quartz ruby korn floral cracked chalky granite wonder vegan earth strata mineral alumina collegiate clear sky core true bone fawn marsh heather caper salmon sea moss tofu grisaille nights vanilla etherea hybrid pebbled timberwolf pastel plum explosion tech century wine raincloud polka dots discovery age beef broccoli december sky castlerock caged outerspace salt surf grey matter pure platinum anthracite orewood bigeon dodgers azul chlorophyll burn raised abstract art valerian syracuse blaze racer bordeaux disrupt negro blanco trangelove purple pulse aura michigan state flax wow lv8 smoke paycheck mini box dust photon chrome toe paruque mink nylon stardust cedar team bronzine craft valentines valantains next nature phantom arctic punch golf ginger peach grass bill kill mustard seed ankle braided trim goat button oak hickory caspian curly maxi';
  var VOCAB = {};
  function addWords(str, w) {
    str.split(/\s+/).forEach(function (x) { if (x && (!VOCAB[x] || VOCAB[x] < w)) VOCAB[x] = w; });
  }
  addWords(OTHER, 1);
  addWords(MODELS, 2);
  addWords(BRANDS, 3);

  // alias -> replacement (Arabic, Franco spellings, plural/colloquial)
  var ALIASES = {
    'نايك': 'nike', 'نايكي': 'nike', 'نيكي': 'nike', 'naiki': 'nike', 'nayki': 'nike', 'nayk': 'nike', 'naik': 'nike',
    'جوردن': 'jordan', 'جوردان': 'jordan', 'جوردون': 'jordan', 'جردن': 'jordan', 'jordans': 'jordan',
    'اديداس': 'adidas', 'أديداس': 'adidas', 'ادداس': 'adidas', 'اديدس': 'adidas', 'adedas': 'adidas', 'adidass': 'adidas',
    'نيو بالانس': 'new balance', 'نيوبالانس': 'new balance', 'نيو بلانس': 'new balance', 'newbalance': 'new balance', 'nb': 'new balance',
    'بوما': 'puma', 'اسيكس': 'asics', 'أسيكس': 'asics', 'اسكس': 'asics',
    'اون كلاود': 'on cloud', 'اون': 'on', 'كلاود': 'cloud', 'اون رانينج': 'on running',
    'اونيتسوكا': 'onitsuka', 'اونيستوكا': 'onitsuka', 'اونتسوكا': 'onitsuka', 'اونيتسوكا تايجر': 'onitsuka tiger', 'تايجر': 'tiger',
    'سالومون': 'salomon', 'بيركنستوك': 'birkenstock', 'بيركنشتوك': 'birkenstock', 'بيركنستك': 'birkenstock', 'بركنستوك': 'birkenstock', 'birkenstok': 'birkenstock',
    'اج': 'ugg', 'أج': 'ugg', 'اغ': 'ugg', 'يو جي جي': 'ugg', 'اجز': 'ugg', 'أجز': 'ugg',
    'زيجنا': 'zegna', 'زينيا': 'zegna', 'زغنا': 'zegna', 'لورو بيانا': 'loro piana', 'لورو': 'loro', 'لوروبيانا': 'loro piana', 'loropiana': 'loro piana',
    'هيرميس': 'hermes', 'هرمس': 'hermes', 'جولدن جوس': 'golden goose', 'جولدن جوز': 'golden goose', 'جولدن': 'golden', 'goldengoose': 'golden goose',
    'بالنسياجا': 'balenciaga', 'بالانسياجا': 'balenciaga', 'بلنسياجا': 'balenciaga', 'balanciaga': 'balenciaga',
    'الكسندر ماكوين': 'alexander mcqueen', 'ماكوين': 'mcqueen',
    'اوف وايت': 'off white', 'اوفوايت': 'off white', 'offwhite': 'off white',
    'لويس فيتون': 'louis vuitton', 'لويس فويتون': 'louis vuitton', 'louisvuitton': 'louis vuitton', 'ال في': 'lv',
    'ديور': 'dior', 'فالنتينو': 'valentino', 'مارجيلا': 'margiela', 'ميزون مارجيلا': 'maison margiela', 'ميزون': 'maison',
    'برونيلو': 'brunello', 'كوتشينيلي': 'cucinelli', 'جوتشي': 'gucci', 'جوتشى': 'gucci', 'جوتشيه': 'gucci', 'برادا': 'prada',
    'شانيل': 'chanel', 'ميو ميو': 'miu miu', 'سان لوران': 'saint laurent', 'فندي': 'fendi', 'مونكلير': 'moncler', 'سانتوني': 'santoni', 'فالنتينو': 'valentino',
    'اير فورس': 'air force', 'ايرفورس': 'air force', 'airforce': 'air force', 'اير ماكس': 'air max', 'ايرماكس': 'air max', 'airmax': 'air max',
    'دانك': 'dunk', 'دنك': 'dunk', 'سامبا': 'samba', 'جازيل': 'gazelle', 'جزيل': 'gazelle', 'كامبس': 'campus', 'كامبوس': 'campus',
    'سبيزال': 'spezial', 'سبيزيال': 'spezial', 'ييزي': 'yeezy', 'يزي': 'yeezy', 'كورتيز': 'cortez', 'بليزر': 'blazer', 'مكسيكو': 'mexico', 'ميكسيكو': 'mexico',
    'سوبر ستار': 'super star', 'سبيد كات': 'speedcat', 'ستار': 'star', 'تاسمان': 'tasman', 'اريزونا': 'arizona', 'بوسطن': 'boston',
    'كوتشي': 'sneakers', 'كوتشى': 'sneakers', 'كوتش': 'sneakers', 'كوتشيات': 'sneakers', 'كوتشيهات': 'sneakers', 'حذاء': 'sneakers', 'احذية': 'sneakers', 'حذاء رياضي': 'sneakers', 'جزمة': 'sneakers', 'جزمه': 'sneakers', 'جزم': 'sneakers', 'سنيكرز': 'sneakers', 'سنيكر': 'sneakers', 'sneakerz': 'sneakers', 'snekers': 'sneakers', 'sneeker': 'sneakers', 'sniker': 'sneakers', 'snikers': 'sneakers', 'sneker': 'sneakers',
    'صندل': 'sandal', 'سندل': 'sandal', 'صنادل': 'sandals', 'شبشب': 'slippers', 'شباشب': 'slippers', 'سلايد': 'slides', 'سلايدز': 'slides', 'بوت': 'boots', 'بوتس': 'boots', 'بوتات': 'boots', 'لوفر': 'loafers', 'لوفرز': 'loafers', 'باليرينا': 'ballerina', 'باليه': 'ballet',
    'اسود': 'black', 'أسود': 'black', 'ابيض': 'white', 'أبيض': 'white', 'رمادي': 'grey', 'احمر': 'red', 'أحمر': 'red', 'ازرق': 'blue', 'أزرق': 'blue', 'اخضر': 'green', 'أخضر': 'green', 'بيج': 'beige', 'بني': 'brown', 'وردي': 'pink', 'بينك': 'pink', 'كحلي': 'navy', 'ذهبي': 'gold', 'فضي': 'silver', 'برتقالي': 'orange', 'اصفر': 'yellow', 'أصفر': 'yellow', 'بنفسجي': 'purple', 'موف': 'purple',
    'حريمي': 'women', 'نسائي': 'women', 'بناتي': 'women', 'حريمى': 'women', 'اطفال': 'kids', 'أطفال': 'kids', 'رجالي': '', 'رجالى': '', 'ولادي': 'kids'
  };

  function normalizeArabic(s) {
    return s
      .replace(/[ً-ْـ]/g, '')
      .replace(/[أإآ]/g, 'ا')
      .replace(/ى/g, 'ي')
      .replace(/ة/g, 'ه')
      .replace(/ؤ/g, 'و')
      .replace(/ئ/g, 'ي')
      .replace(/[٠-٩]/g, function (d) { return String(d.charCodeAt(0) - 1632); });
  }
  function norm(s) {
    return normalizeArabic(String(s || '').toLowerCase())
      .replace(/[‘’'`"]/g, '')
      .replace(/[^a-z0-9؀-ۿ\s]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  var ALIAS = {};
  Object.keys(ALIASES).forEach(function (k) {
    var nk = norm(k);
    if (!nk) return;
    ALIAS[nk] = ALIASES[k];
  });
  var MAX_ALIAS_WORDS = 3;

  function applyAliases(tokens) {
    var out = [];
    var i = 0;
    while (i < tokens.length) {
      var hit = false;
      for (var n = Math.min(MAX_ALIAS_WORDS, tokens.length - i); n >= 1; n--) {
        var key = tokens.slice(i, i + n).join(' ');
        if (Object.prototype.hasOwnProperty.call(ALIAS, key)) {
          if (ALIAS[key]) out.push.apply(out, ALIAS[key].split(' '));
          i += n;
          hit = true;
          break;
        }
      }
      if (!hit) { out.push(tokens[i]); i++; }
    }
    return out;
  }

  function skeleton(w) {
    return w.charAt(0) + w.slice(1).replace(/[aeiouyhw]/g, '').replace(/(.)\1+/g, '$1');
  }

  // optimal string alignment distance (Damerau-Levenshtein with adjacent transpositions)
  function dist(a, b, max) {
    var la = a.length, lb = b.length;
    if (Math.abs(la - lb) > max) return max + 1;
    var d = [], i, j;
    for (i = 0; i <= la; i++) { d[i] = [i]; }
    for (j = 0; j <= lb; j++) { d[0][j] = j; }
    for (i = 1; i <= la; i++) {
      for (j = 1; j <= lb; j++) {
        var c = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
        d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + c);
        if (i > 1 && j > 1 && a.charAt(i - 1) === b.charAt(j - 2) && a.charAt(i - 2) === b.charAt(j - 1)) {
          d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
        }
      }
    }
    return d[la][lb];
  }

  var WORDS = Object.keys(VOCAB);
  var SKEL = {};
  WORDS.forEach(function (w) { var k = skeleton(w); (SKEL[k] = SKEL[k] || []).push(w); });

  function hasPrefix(tok) {
    for (var i = 0; i < WORDS.length; i++) if (WORDS[i].indexOf(tok) === 0) return true;
    return false;
  }

  function nearest(tok) {
    var len = tok.length;
    if (len < 4) return null;
    var max = len <= 5 ? 1 : len <= 9 ? 2 : 3;
    var best = null, bestD = 99, bestW = 0;
    for (var i = 0; i < WORDS.length; i++) {
      var w = WORDS[i];
      if (Math.abs(w.length - len) > max) continue;
      if (w.length < 4) continue;
      var d = dist(tok, w, max);
      if (d > max) continue;
      var weight = VOCAB[w];
      if (d < bestD || (d === bestD && weight > bestW)) { best = w; bestD = d; bestW = weight; }
    }
    if (!best) {
      var sk = skeleton(tok);
      var list = SKEL[sk];
      if (list) {
        for (var j = 0; j < list.length; j++) {
          if (list[j].length >= 4 && Math.abs(list[j].length - len) <= 2 && VOCAB[list[j]] > bestW) { best = list[j]; bestW = VOCAB[list[j]]; }
        }
      }
    }
    return best;
  }

  function splitJoined(tok) {
    if (tok.length < 6 || VOCAB[tok]) return null;
    for (var i = 3; i <= tok.length - 3; i++) {
      var a = tok.slice(0, i), b = tok.slice(i);
      if (VOCAB[a] && VOCAB[b]) return [a, b];
    }
    return null;
  }

  function isLatin(t) { return /^[a-z0-9]+$/.test(t); }

  function mergeKnown(tokens) {
    var merged = [];
    for (var k = 0; k < tokens.length; k++) {
      var m = k < tokens.length - 1 ? tokens[k] + tokens[k + 1] : '';
      if (m && VOCAB[m] && !(VOCAB[tokens[k]] >= 2 && VOCAB[tokens[k + 1]] >= 2 && tokens[k].length > 3 && tokens[k + 1].length > 3)) {
        merged.push(m); k++;
      } else merged.push(tokens[k]);
    }
    return merged;
  }

  function correct(tokens, typing) {
    tokens = mergeKnown(tokens);
    var out = [];
    for (var i = 0; i < tokens.length; i++) {
      var t = tokens[i];
      var last = i === tokens.length - 1;
      if (!isLatin(t) || /^\d+$/.test(t) || t.length < 4 || VOCAB[t]) { out.push(t); continue; }
      if (last && typing && hasPrefix(t)) { out.push(t); continue; }
      var sp = splitJoined(t);
      if (sp) { out.push(sp[0], sp[1]); continue; }
      var near = nearest(t);
      out.push(near || t);
    }
    return out;
  }

  /** Returns candidate queries in the order they should be tried. */
  function candidates(raw, typing) {
    var base = norm(raw);
    if (!base) return [];
    var tokens = base.split(' ');
    var aliased = applyAliases(tokens);
    var list = [];
    function push(arr) {
      var q = arr.join(' ').trim();
      if (q && list.indexOf(q) === -1) list.push(q);
    }
    push(aliased);
    var fixed = correct(aliased, typing);
    push(fixed);
    // relaxed: progressively drop trailing words, then keep brand/model words only
    for (var n = fixed.length - 1; n >= 1; n--) {
      var part = fixed.slice(0, n);
      if (part.length === 1 && !(part[0].length >= 4 || VOCAB[part[0]] === 3)) continue;
      push(part);
    }
    var core = fixed.filter(function (t) { return VOCAB[t] >= 2; });
    if (core.length) push(core);
    var brands = fixed.filter(function (t) { return VOCAB[t] === 3; });
    if (brands.length) push(brands);
    return list.slice(0, 6);
  }

  window.SnatchedSearch = { candidates: candidates, norm: norm, vocabSize: WORDS.length };

  // ---------- styles ----------
  var css = '' +
    '.sn-search-note{display:flex;flex-wrap:wrap;gap:6px;align-items:center;margin:0 0 10px;padding:9px 12px;border-radius:10px;background:#eaf5f3;color:#1b3a37;font-size:13px;line-height:1.4}' +
    '.sn-search-note b{color:#0b7a74;font-weight:600}' +
    '.sn-search-note a{color:#5444c8;text-decoration:underline;text-underline-offset:2px}' +
    '.sn-search-banner{max-width:var(--page-width,1200px);margin:12px auto 0;padding:0 var(--page-margin,16px)}' +
    '.sn-search-banner .sn-search-note{margin:0}' +
    '.sn-chips{display:flex;flex-wrap:wrap;gap:8px;margin:0 0 14px}' +
    '.sn-chip{display:inline-flex;align-items:center;min-height:36px;padding:0 14px;border-radius:999px;border:1px solid #c9dcd9;background:#f3faf9;color:#1b3a37;font-size:13px;text-decoration:none;white-space:nowrap}' +
    '.sn-chip:hover{background:#e1f2ef;border-color:#0b7a74}' +
    '.sn-chips-title{font-size:12px;font-weight:600;letter-spacing:.04em;text-transform:uppercase;color:#4d607a;margin:0 0 8px}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function hasResults(html) {
    return /predictive-search-results__card--product/.test(html) || /predictive-search-results__card(?![-\w])/.test(html);
  }
  function noteHtml(shown, original, exact) {
    var msg = exact
      ? 'Showing results for <b>' + esc(shown) + '</b>'
      : 'No exact match for “' + esc(original) + '”. Showing the closest results for <b>' + esc(shown) + '</b>';
    return '<div class="sn-search-note" role="status"><span>' + msg + '</span></div>';
  }

  // ---------- predictive search (dropdown) ----------
  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : input && input.url;
      if (!url || url.indexOf('/search/suggest') === -1 || url.indexOf('section_id=predictive-search') === -1 || url.indexOf('suggest.json') !== -1) {
        return nativeFetch.apply(this, arguments);
      }
      var u;
      try { u = new URL(url, location.origin); } catch (e) { return nativeFetch.apply(this, arguments); }
      var q = u.searchParams.get('q');
      if (!q) return nativeFetch.apply(this, arguments);
      u.searchParams.set('resources[limit]', '10');
      u.searchParams.set('resources[options][unavailable_products]', 'last');

      var cands = candidates(q, true);
      if (!cands.length) cands = [q];
      var origNorm = norm(q);
      var self = this;
      var signal = init && init.signal;

      function attempt(i) {
        var qu = new URL(u.toString());
        qu.searchParams.set('q', cands[i]);
        return nativeFetch.call(self, qu.toString(), { signal: signal }).then(function (res) {
          return res.text().then(function (html) {
            var ok = hasResults(html);
            if (ok || i === cands.length - 1) {
              if (ok && cands[i] !== origNorm) {
                var exact = i <= 1;
                html = html.replace(/(data-search-results[^>]*>)/, '$1' + noteHtml(cands[i], q.trim(), exact));
              }
              return new Response(html, { status: res.status, statusText: res.statusText, headers: res.headers });
            }
            return attempt(i + 1);
          });
        });
      }
      return attempt(0).catch(function (err) {
        if (signal && signal.aborted) throw err;
        return nativeFetch.apply(self, [url, init]);
      });
    };
  }

  // ---------- full search page ----------
  function onSearchPage() {
    var info = window.SNATCHED_SEARCH_PAGE;
    if (!info || !info.terms) return;
    var params = new URLSearchParams(location.search);
    var from = params.get('sn_from');
    var main = document.getElementById('MainContent');
    function banner(html) {
      if (!main) return;
      var d = document.createElement('div');
      d.className = 'sn-search-banner';
      d.innerHTML = html;
      main.insertBefore(d, main.firstChild);
    }
    if (info.count > 0) {
      if (from) {
        var back = '/search?q=' + encodeURIComponent(from) + '&sn_raw=1';
        banner('<div class="sn-search-note" role="status"><span>Showing results for <b>' + esc(info.terms) + '</b>. <a href="' + back + '">Search instead for “' + esc(from) + '”</a></span></div>');
      }
      return;
    }
    var cands = candidates(info.terms, false);
    var idx = 0;
    function next() {
      if (idx >= cands.length) { return noResult(); }
      var c = cands[idx++];
      if (c === norm(info.terms)) return next();
      nativeFetch('/search/suggest.json?q=' + encodeURIComponent(c) + '&resources[type]=product&resources[limit]=1')
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var p = j && j.resources && j.resources.results && j.resources.results.products;
          if (p && p.length) {
            location.replace('/search?q=' + encodeURIComponent(c) + '&sn_from=' + encodeURIComponent(info.terms));
          } else next();
        })
        .catch(function () { next(); });
    }
    function noResult() {
      var links = ['Nike', 'Jordan', 'Adidas', 'New Balance', 'ON Cloud', 'Onitsuka Tiger', 'Birkenstock', 'UGG'].map(function (b) {
        return '<a class="sn-chip" href="/search?q=' + encodeURIComponent(b) + '">' + b + '</a>';
      }).join('');
      banner('<div class="sn-search-note" role="status"><span>We could not find “' + esc(info.terms) + '”. Try a brand name or a shorter word:</span></div><div class="sn-chips" style="margin-top:10px">' + links + '</div>');
    }
    if (from || params.get('sn_raw')) { noResult(); return; }
    next();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onSearchPage);
  else onSearchPage();
})();
